export default "__VITE_ASSET__DlFMr3Sa__"